import React from "react";
import { PDFViewer } from "@react-pdf/renderer";
import { createAgreementElement } from "../_helpers/agreementHelper";

function AgreementViewer({ agreementKey, form, plaidData, agreement }) {
  if (!agreementKey) return null;

  const agreementElement = createAgreementElement(agreementKey, {
    form,
    plaidData,
    agreement,
  });

  return (
    <PDFViewer
      width="100%"
      height="500px"
      showToolbar={false}
      style={{ border: "none" }}
    >
      {agreementElement}
    </PDFViewer>
  );
}

export default AgreementViewer;
